import { configureStore } from "@reduxjs/toolkit";
import carsReducer from "../slices/cars-slice";
import authReducer from "../slices/auth-slice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    cars: carsReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
